export enum AnalyticsPermissions {
  VIEW_EMBEDDED_DASHBOARD = 'analytics.viewEmbeddedDashboard',
  GET_CHART_DATA = 'analytics.getChartData',
  RUN_SELF_SERVE_QUERY = 'analytics.runSelfServeQuery',
}
